import { m, AnimatePresence } from 'framer-motion';
// @mui
import { Dialog, Box, Paper, DialogProps, Breakpoint } from '@mui/material';
//
import { varFade } from './variants';
import { useMemo } from 'react';
import { v4 as uuidv4 } from 'uuid';
// ----------------------------------------------------------------------

export interface Props extends DialogProps {
    variants?: Record<string, unknown>;
    onClose?: VoidFunction;
    maxWidth?: Breakpoint | false
}

export default function DialogAnimate({
    open = false,
    variants,
    onClose,
    children,
    maxWidth = 'xs',
    sx,
    ...other
}: Props) {
    const id = useMemo(() => uuidv4(), []);

    return (
        <AnimatePresence>
            {open && (
                <Dialog
                    key={id}
                    fullWidth
                    maxWidth={maxWidth}
                    open={open}
                    onClose={onClose}
                    PaperComponent={(props) => (
                        <Box
                            component={m.div}
                            {...(variants ||
                                varFade({
                                    distance: 120,
                                    durationIn: 0.32,
                                    durationOut: 0.24,
                                    easeIn: 'easeInOut',
                                }).inUp)}
                            sx={{
                                width: '100%',
                                height: '100%',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                            }}
                        >
                            <Box onClick={onClose} sx={{ width: '100%', height: '100%', position: 'fixed' }} />
                            <Paper sx={sx} {...props}>
                                {props.children}
                            </Paper>
                        </Box>
                    )}
                    {...other}
                >
                    {children}
                </Dialog>
            )}
        </AnimatePresence>
    );
}
